import _ = require("lodash");
import { IColumnConfig } from "../configuration";
import { currentResource } from "../../util/utils";
import Utility from "../../util/utilityFunctions";
export class TemplateEditClientRequestConfiguration implements IColumnConfig {
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: "status",
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
        },
        CellData: {
          value: 3,
          resourceName: "uploadStatusLabels",
        },
      },
      {
        CellHeader: "updateCanvas",
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
        },
        CellData: {
          value: "No",
        },
      },
      {
        CellHeader: "clientRequestTitle",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestTitle",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          requiredColumnWidth: 168.66,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [7, 12, 15, 18, 19, 8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.requestTitle;
        },
        // CellData: {
        //   dataAttributeName: "requestTitle",
        // },
      },
      {
        CellHeader: "clientRequestDescription",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestFormatedDescription",
        dataType: "richText",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          requiredColumnWidth: 278.27,
          wrapText: true,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [7, 12, 15, 18, 19, 8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return Utility.getFormatedDescriptionToExcelFormat(data?.requestDescription ?? "");
        },
        // CellData: {
        //   dataAttributeName: "requestDescription",
        // },
      },
      {
        CellHeader: "AssignedToGroup",
        CellId: "assignedToGroups",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        referenceData: {
          sourceDataObjectName: "assignedToGroupsreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "F",
          referenceDataCellNameEndAddress: "G",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        cellToBindDropDown: true,
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const clientGroupId = data?.clientGroupID;
          const clientUserId = data?.clientUserID;

          if (clientGroupId && !clientUserId)
            return referenceData?.clientGroupsData?.find((group) => group.groupId == clientGroupId)?.groupName;
          return "";
        },
      },
      // CellData: {
      //   cellDataTemplate:
      //     "{ return `${rowData.clientGroupName && !rowData.clientUserID ? rowData.clientGroupName : ''}`} ",
      // },
      {
        CellHeader: "AssignedToUser",
        CellId: "assignedToUsers",
        cellToBindDropDown: true,
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        referenceData: {
          sourceDataObjectName: "assignedToUsersreferenceData",
          parentDataAttributeId: "assignedToGroups",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "I",
          referenceDataCellNameEndAddress: "M",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "username", "groupname", "id", "parentId"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const clientGroupId = data?.clientGroupID;
          const clientUserId = data?.clientUserID;

          if (clientUserId && referenceData?.externalUsersData) {
            const user = referenceData.externalUsersData.find((u) => u.userId == clientUserId && u.groupId == clientGroupId);
            return user?.groupMember;
          }
          return "";
        },
        // CellData: {
        //   cellDataTemplate:
        //     "{ return `${rowData.fullName?.trim() && rowData.clientUserID ? rowData.clientGroupName: ''}${rowData.fullName?.trim() && rowData.clientUserID ? ':' : '' } ${rowData.fullName?.trim() && rowData.clientUserID ? rowData.fullName : ''}` } ",
        // },
      },
      {
        CellHeader: "DueDate",
        CellId: "DueDate",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          dateFormat: true,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.dueDate?.split("T")[0];
        },
        // CellData: {
        //   cellDataTemplate: "{ return `${rowData.dueDate?.split('T')[0] ? rowData.dueDate?.split('T')[0] : ''}`} ",
        // },
      },
      {
        CellHeader: "eyContact",
        CellId: "eyContacts",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        referenceData: {
          sourceDataObjectName: "eyContactsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "O",
          referenceDataCellNameEndAddress: "P",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        CellData: {
          dataAttributeName: "fullName",
          sourceDataAttributeName: "followers",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate: "{ return `${item.firstName.replace(/;/g, '_')} ${item.lastName.replace(/;/g, '_')}` } ",
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const followers = data?.followers ?? [];
          if (!followers || followers.length === 0) return "";

          const names = followers.map((follower) => {
            const match = referenceData?.internalUsersData?.find(
              (contact) => contact.userId === follower.followedByUserId
            );
            return match ? match.name : "";
          });

          return names.join("; ");
        },
      },
      {
        CellHeader: "tags",
        CellId: "Tags",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        referenceData: {
          sourceDataObjectName: "TagsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "R",
          referenceDataCellNameEndAddress: "U",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "color", "des", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        CellData: {
          dataAttributeName: "engagementTagName",
          sourceDataAttributeName: "tagsList",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate:
            "{ return `${item.engagementTagName.includes(';') ? item.engagementTagName.replace(/;/g, '_') : item.engagementTagName } (${item.colorCode})` } ",
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const tagsList = data?.tagsList;
          let taskTags = "";

          tagsList.length > 0 &&
            tagsList.forEach((tag, index) => {
              const matchingGroup = referenceData?.tagsData?.find((group) => group.tagId == tag.engagementTagID);
              if (matchingGroup) {
                taskTags += matchingGroup?.tagName;
                if (index < tagsList.length - 1) {
                  taskTags += "; ";
                }
              }
            });

          return taskTags;
        },
      },
      {
        CellHeader: "priority",
        CellId: "priority",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "priorityreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "C",
          referenceDataCellNameEndAddress: "D",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [7, 12, 15, 18, 19, 8, 28],
          },
        },
        // CellData: {
        //   dataAttributeName: "priorityTypeID",
        //   resourceName: "priorityTypesCollaboration",
        // },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return currentResource.priorityTypesCollaboration?.find((pt) => pt.value === data?.priorityTypeID)?.label;
        },
      },
      {
        CellHeader: "timephases",
        CellId: "timephases",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "timephasesreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "W",
          referenceDataCellNameEndAddress: "Z",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "startdate", "endDate", "id"],
        },
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
          lockedCondition: {
            dataAttributeName: "clientRequestStatusID",
            clientRequestStatusID: [8, 28],
          },
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.timephaseName;
        },
        // CellData: {
        //   dataAttributeName: "timephaseName",
        // },
      },
      {
        CellHeader: "requestStatus",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        // CellData: {
        //   resourceName: "clientRequestStatusType",
        //   dataAttributeName: "clientRequestStatusID",
        // },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return currentResource.clientRequestStatusType[data?.clientRequestStatusID];
        },
      },
      {
        CellHeader: "requestHashSpace",
        CellId: "Request",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        // CellData: {
        //   dataAttributeName: "referenceNumber",
        // },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.referenceNumber;
        },
      },
      {
        CellHeader: "clientRequestTitleSpace",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "originalClientRequestTitle",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          requiredColumnWidth: 168.66,
        },
        // CellData: {
        //   dataAttributeName: "requestTitle",
        // },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.requestTitle;
        },
      },
      {
        CellHeader: "clientRequestDescriptionSpace",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "originalClientRequestDescription",
        dataType: "richText",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          requiredColumnWidth: 278.27,
          disableDefaultFormatting: true,
          wrapText: true,
        },
        // CellData: {
        //   dataAttributeName: "requestDescription",
        // },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return Utility.getFormatedDescriptionToExcelFormat(data?.requestDescription ?? "");
        },
      },
      {
        CellHeader: "AssignedToGroupSpace",
        CellId: "originalAssignedToGroup",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const clientGroupId = data?.clientGroupID;
          const clientUserId = data?.clientUserID;

          if (clientGroupId && !clientUserId)
            return referenceData?.clientGroupsData?.find((group) => group.groupId == clientGroupId)?.groupName;
          return "";
        },
        // CellData: {
        //   cellDataTemplate:
        //     "{ return `${rowData.clientGroupName && !rowData.clientUserID ? rowData.clientGroupName : ''}`} ",
        // },
      },
      {
        CellHeader: "AssignedToUserSpace",
        CellId: "originalAssignedToUser",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const clientGroupId = data?.clientGroupID;
          const clientUserId = data?.clientUserID;

          if (clientUserId && referenceData?.externalUsersData) {
            const user = referenceData.externalUsersData.find((u) => u.userId == clientUserId && u.groupId == clientGroupId);
            return user?.groupMember;
          }
          return "";
        },
        // CellData: {
        //   cellDataTemplate:
        //     "{ return `${rowData.fullName?.trim() && rowData.clientUserID ? rowData.clientGroupName: ''}${rowData.fullName?.trim() && rowData.clientUserID ? ':' : '' } ${rowData.fullName?.trim() && rowData.clientUserID ? rowData.fullName : ''}` } ",
        // },
      },
      {
        CellHeader: "DueDateSpace",
        CellId: "originalDueDate",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          dateFormat: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.dueDate?.split("T")[0];
        },
        // CellData: {
        //   cellDataTemplate: "{ return `${rowData.dueDate?.split('T')[0] ? rowData.dueDate?.split('T')[0] : ''}`} ",
        // },
      },
      {
        CellHeader: "eyContactSpace",
        CellId: "originalEyContacts",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
           const followers = data?.followers ?? [];
          if (!followers || followers.length === 0) return "";

          const names = followers.map((follower) => {
            const match = referenceData?.internalUsersData?.find(
              (contact) => contact.userId === follower.followedByUserId
            );
            return match ? match.name : "";
          });

          return names.join("; ");
        },
        CellData: {
          sourceDataAttributeName: "followers",
          dataAttributeName: "fullName",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate: "{ return `${item.firstName.replace(/;/g, '_')} ${item.lastName.replace(/;/g, '_')}` }",
        },
      },
      {
        CellHeader: "tagsSpace",
        CellId: "originalTags",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const tagsList = data?.tagsList;
          let taskTags = "";

          tagsList.length > 0 &&
            tagsList.forEach((tag, index) => {
              const matchingGroup = referenceData?.tagsData?.find((group) => group.tagId == tag.engagementTagID);
              if (matchingGroup) {
                taskTags += matchingGroup?.tagName;
                if (index < tagsList.length - 1) {
                  taskTags += "; ";
                }
              }
            });

          return taskTags;
        },
        CellData: {
          dataAttributeName: "engagementTagName",
          sourceDataAttributeName: "tagsList",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate:
            "{ return `${item.engagementTagName.includes(';') ? item.engagementTagName.replace(/;/g, '_') : item.engagementTagName } (${item.colorCode})` } ",
        },
      },
      {
        CellHeader: "prioritySpace",
        CellId: "originalPriority",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return currentResource.priorityTypesCollaboration?.find((pt) => pt.value === data?.priorityTypeID)?.label;
        },
        // CellData: {
        //   dataAttributeName: "priorityTypeID",
        //   resourceName: "priorityTypesCollaboration",
        // },
      },
      {
        CellHeader: "timephasesSpace",
        CellId: "originalTimePhase",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          return data?.timephaseName;
        },
      },
      {
        CellHeader: "requestStatusId",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestStatusTypeId",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          columnHidden: true,
        },
        CellData: {
          dataAttributeName: "clientRequestStatusID",
        },
      },
      {
        CellHeader: "requestId",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestID",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          columnHidden: true,
        },
        CellData: {
          dataAttributeName: "clientRequestID",
        },
      },
      {
        CellHeader: "requestGuid",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestGUID",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          columnHidden: true,
        },
        CellData: {
          dataAttributeName: "clientRequestGUID",
        },
      },
      {
        CellHeader: "hash",
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            { CellId: "clientRequestTitle", dataAttributeName: "requestTitle" },
            { CellId: "clientRequestFormatedDescription" },
            { CellId: "assignedToGroups" },
            { CellId: "assignedToUsers" },
            { CellId: "DueDate" },
            { CellId: "eyContacts" },
            { CellId: "Tags" },
            { CellId: "priority" },
            { CellId: "timephases", dataAttributeName: "timephaseName" },
          ],
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data, referenceData); // can be more then one
          return hashValue;
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          columnHidden: true,
        },
      },
      {
        CellHeader: "statusID",
        CellId: "UploadStatusId",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          columnHidden: true,
        },
        CellData: {
          value: 3,
        },
      },
    ];
  }
}

export class TemplateAddClientRequestConfiguration implements IColumnConfig {
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: "status",
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
        },
      },
      {
        CellHeader: "updateCanvas",
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
        },
      },
      {
        CellHeader: "clientRequestTitle",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "clientRequestTitle",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
      },
      {
        CellHeader: "clientRequestDescription",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        dataType: "richText",
        CellId: "clientRequestFormatedDescription",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          wrapText: true,
        },
      },
      {
        CellHeader: "AssignedToGroup",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "assignedToGroups",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "assignedToGroupsreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "F",
          referenceDataCellNameEndAddress: "G",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          inputMessageRequired: true,
          horizontalAlignment: "Left",
        },
      },
      {
        CellHeader: "AssignedToUser",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "assignedToUsers",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "assignedToUsersreferenceData",
          parentDataAttributeId: "assignedToGroups",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "I",
          referenceDataCellNameEndAddress: "M",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "username", "groupname", "id", "parentId"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          inputMessageRequired: true,
          horizontalAlignment: "Left",
        },
      },
      {
        CellHeader: "DueDate",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "DueDate",
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
          dateFormat: true,
        },
      },
      {
        CellHeader: "eyContact",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "eyContacts",
        referenceData: {
          sourceDataObjectName: "eyContactsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "O",
          referenceDataCellNameEndAddress: "P",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        CellData: {
          dataAttributeName: "fullName",
          sourceDataAttributeName: "followers",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate: "",
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
        },
      },
      {
        CellHeader: "tags",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "Tags",
        referenceData: {
          sourceDataObjectName: "TagsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "R",
          referenceDataCellNameEndAddress: "U",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "color", "des", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
        },
        CellData: {
          dataAttributeName: "engagementTagName",
          sourceDataAttributeName: "tagsList",
          seprator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate: "",
        },
      },
      {
        CellHeader: "priority",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "priority",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "priorityreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "C",
          referenceDataCellNameEndAddress: "D",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
        },
      },
      {
        CellHeader: "timephases",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellId: "timephases",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "timephasesreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "W",
          referenceDataCellNameEndAddress: "Z",
          referenceDataCellRowStartIndex: "5",
          referenceDataCellRowIndexMax: "1000",
          outputDataattributes: ["value", "startDate", "endDate", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: "#ffffff",
          horizontalAlignment: "Left",
        },
      },
      {
        CellHeader: "requestGuid",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          columnHidden: true,
        },
      },
      {
        CellHeader: "requestId",
        CellHeaderResourceName: "clientrequestInputSheetMainHeaders",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          horizontalAlignment: "Left",
          columnHidden: true,
        },
      },
      {
        CellHeader: "hash",
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            { CellId: "clientRequestTitle" },
            { CellId: "clientRequestFormatedDescription" },
            { CellId: "assignedToGroups" },
            { CellId: "assignedToUsers" },
            { CellId: "DueDate" },
            { CellId: "eyContacts" },
            { CellId: "Tags" },
            { CellId: "priority" },
            { CellId: "timephases" },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          columnHidden: true,
        },
      },
      {
        CellHeader: "statusId",
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: "#3A3A3A",
          RowsFillColor: "D3D3D3",
          columnHidden: true,
          horizontalAlignment: "Left",
        },
      },
    ];
  }
}
